import { motion, useReducedMotion } from "framer-motion";
import type { ReactNode } from "react";

// One restrained scroll reveal used across the site: a short fade + 12px rise,
// once. Nothing moves for people who ask for reduced motion.
export const Reveal = ({
  children,
  delay = 0,
  y = 12,
  className,
}: {
  children: ReactNode;
  delay?: number;
  y?: number;
  className?: string;
}) => {
  const reduce = useReducedMotion();
  // The prerenderer snapshots pages in headless Chrome without scrolling. Rendering
  // plain markup there keeps below-the-fold content visible in the static HTML.
  const prerendering = typeof navigator !== "undefined" && /HeadlessChrome/.test(navigator.userAgent);
  if (reduce || prerendering) return <div className={className}>{children}</div>;
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: y > 12 ? 0.7 : 0.45, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
};
